import { render } from "./DelReferent.vue?vue&type=template&id=5d87d8ae"
import script from "./DelReferent.vue?vue&type=script&lang=js"
export * from "./DelReferent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__